<template>
  <div class="container">
    <div class="main-title">Games</div>
    <div class="game project-synthecite">
      <div class="image" @click="$router.push('games/project-synthecite')">
        <img src="@/assets/studio-page/project-synthecite2.png" alt="project-synthecite">
      </div>
      <div class="description">
        <div class="title">Project Synthecite</div>
        <div class="text">
          A 2D pixel art atmospheric sci-fi horror game with a focus on narrative, puzzles, and survival.
          Using a unique blend of retro-futuristic and cyberpunk aesthetics, Project Synthecite aims to deliver a unique and immersive experience that will leave you questioning your own sanity.
          Use your AI companion to intelligently inform you about the world, as well as utilize a unique set of hacking tools to control the ship's vast network of devices and technology.
        </div>
      </div>
    </div>
    <div class="game beat-bash">
      <div class="image" @click="goTo('https://overlook-studios.itch.io/beat-bash')">
        <img src="@/assets/studio-page/beat-bash-ld47.png" alt="beat-bash">
      </div>
      <div class="description">
        <div class="title">Beat Bash</div>
        <div class="text">A rhythm inspired cardbuilding roguelike where you must defeat enemies on beat using placed runes. Using a unique beat-based combat mechanic, you must defend and attack against a variety of enemies through different areas. <br/><br/>A submission for <a href="https://ldjam.com/events/ludum-dare/47/beat-bash" target="_blank">LD47 game jam</a>, placing 15th overall.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goTo(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">

a {
  color: inherit;
  opacity: 0.75;

  &:hover {
    opacity: 1;
  }
}

.container {
  display:flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 90%;

  .main-title {
    text-align:center;
    font-size: 35px;
    padding-bottom: 30px;
  }

  .game {
    display:flex;
    flex-direction: row;
    justify-content: flex-start;
    border-top: 2px solid white;
    padding-top: 30px;
    margin-bottom: 30px;

    .image {
      height: 200px;
      width: 40%;
      margin-right: 30px;
      cursor: pointer;
      flex-shrink: 0;
      filter: saturate(0.5);
      transition: 0.2s all;
      border: 2px solid #ffffff33;
      border-radius: 2px;
      
      &:hover {
        filter: saturate(1);
        border: 2px solid white;
      }

      img {
        width: auto;
        height: 100%;;
      }
    }

    .description {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items:flex-start;

      .title {
        font-size: 25px;
        margin-bottom: 15px;
        font-weight: bold;
      }

      .text { 
        font-size: 15px;
      }
    }

    &.beat-bash {
      .image {
        text-align: center;
        background-image: url("../../assets/studio-page/beat-bash-bg.png");
        background-position: 60% 53%;
        background-size: 300%;
        background-repeat: no-repeat;
      }
    }

    &.project-synthecite {
      .image {
        overflow: hidden;
      }
    }
  }

}
@media only screen and (max-width: 900px) {
  .game {
    flex-direction: column !important;

    .image { 
      margin-bottom: 20px;
      width: 100% !important;
      filter: unset !important;
    }
  }

  .container {
    .main-title {
      padding-bottom: 15px;
    }
  }

  .game.project-synthecite {
    .image {
      img { 
        width: 100% !important;
        height: auto !important;
        content:url("../../assets/studio-page/project-synthecite-smal.png");
      }
    }
  }
}
@media only screen and (max-width: 500px) {
  .game {
    flex-direction: column !important;

    .image { 
      margin-bottom: 20px;
      width: 100% !important;
    }
  }

  .game.project-synthecite {
    .image {
      img { 
        width: auto !important;
        height: 100% !important;
        content:url("../../assets/studio-page/project-synthecite2.png");
      }
    }
  }
}
</style>